import { AuthorizeService } from './authorize';

const authorizeService = new AuthorizeService();

export { authorizeService };
export * from './authorize';
